  import React, { useState } from "react";

  const Contact = () => {
    const [formData, setFormData] = useState({ name: "", email: "", message: "" });
    const [submitted, setSubmitted] = useState(false);

    const handleChange = (e) => {
      setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleSubmit = (e) => {
      e.preventDefault();
      console.log(formData);
      setSubmitted(true);
      setFormData({ name: "", email: "", message: "" });
      setTimeout(() => setSubmitted(false), 3000);
    };

    return (
      <section style={styles.page}>
        <div style={styles.content}>
          <h1 style={styles.heading}>
            <strong>📩 Contact Us</strong>
            <span style={styles.headingUnderline}></span>
          </h1>
          <p style={styles.subtitle}>
            We'd love to hear from you! Fill out the form below.
          </p>

          <div style={styles.info}>
            <p>📍 <strong>Address:</strong> Near Bhausaheb Cafe, Opp. Ashokrao Mane College of Pharmacy, Peth Vadgaon.
  Tal-Hatakanagale, Dist-Kolhapur 416112.</p>
            <p>📧 <strong>Email:</strong> usahcare.3637@gmail.com</p>
            <p>📞 <strong>Phone:</strong> +91 9637353637</p>
          </div>

          {submitted && (
            <div style={styles.success}>
              ✅ Thank you! Your message has been sent.
            </div>
          )}

          <form onSubmit={handleSubmit} style={styles.form}>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              required
              value={formData.name}
              onChange={handleChange}
              style={styles.input}
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              required
              value={formData.email}
              onChange={handleChange}
              style={styles.input}
            />
            <textarea
              name="message"
              placeholder="Your Message"
              required
              value={formData.message}
              onChange={handleChange}
              style={styles.textarea}
            />
            <button type="submit" style={styles.button}>
              Send Message 🚀
            </button>
          </form>
        </div>
      </section>
    );
  };

  const styles = {
    page: {
      minHeight: "100vh",
      background: "linear-gradient(135deg, #fbe9f0, #fff)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "20px",
      fontFamily: '"Playfair Display", serif',
    },
    content: {
      maxWidth: "500px",
      width: "100%",
      padding: "30px",
      fontFamily: '"Playfair Display", serif',
    },
    heading: {
      fontSize: "2rem",
      textAlign: "center",
      color: "black",
      marginBottom: "40px",
      fontFamily: '"Playfair Display", serif',
      fontWeight: "bold",   // bold text
      position: "relative", // for underline positioning
    },
    headingUnderline: {
      content: '""',
      display: "block",
      width: "60px",
      height: "4px",
      background: "#e91e63",
      margin: "10px auto 0",
      borderRadius: "2px",
      position: "relative",
    },
    subtitle: {
      textAlign: "center",
      color: "#555",
      marginBottom: "20px",
      fontFamily: '"Playfair Display", serif',
    },
    info: {
      fontSize: "0.95rem",
      color: "#444",
      marginBottom: "20px",
      lineHeight: "1.6",
      fontFamily: '"Playfair Display", serif',
    },
    success: {
      background: "#d4edda",
      color: "#155724",
      padding: "10px",
      borderRadius: "5px",
      textAlign: "center",
      marginBottom: "15px",
      animation: "fadeIn 0.4s ease-in-out",
      fontFamily: '"Playfair Display", serif',
    },
    form: {
      display: "flex",
      flexDirection: "column",
      gap: "12px",
    },
    input: {
      padding: "12px 15px",
      fontSize: "1rem",
      border: "1px solid #ccc",
      borderRadius: "8px",
      transition: "0.3s",
      outline: "none",
      fontFamily: '"Playfair Display", serif',
    },
    textarea: {
      padding: "12px 15px",
      fontSize: "1rem",
      border: "1px solid #ccc",
      borderRadius: "8px",
      resize: "vertical",
      minHeight: "100px",
      transition: "0.3s",
      outline: "none",
      fontFamily: '"Playfair Display", serif',
    },
    button: {
      background: "#E91E63",
      color: "#fff",
      padding: "12px",
      fontSize: "1rem",
      borderRadius: "8px",
      border: "none",
      cursor: "pointer",
      transition: "0.3s",
      fontFamily: '"Playfair Display", serif',
      marginBottom: "50px",
    },
  };

  // Hover & focus styling through JS-in-CSS
  ["input", "textarea"].forEach((el) => {
    styles[el][":focus"] = {
      borderColor: "#E91E63",
      boxShadow: "0 0 5px rgba(233,30,99,0.4)",
    };
  });
  styles.button[":hover"] = {
    background: "#C2185B",
  };

  export default Contact;
